import { Button, ButtonProps, ElementProps } from "@mantine/core";

import DisabledReason from "./DisabledReason";

interface DisabledReasonButtonProps extends ButtonProps, ElementProps<"button", keyof ButtonProps> {
  /** Why the button can't be pressed. Setting it disables the button and shows the reason. */
  disabledReason?: string;
}

/**
 * A button that explains why it's disabled. A reason always disables it, so the two can't
 * disagree; `disabled` still covers states with nothing to explain, such as a submit in flight.
 */
export default function DisabledReasonButton({
  disabledReason,
  disabled,
  ...buttonProps
}: DisabledReasonButtonProps) {
  return (
    <DisabledReason reason={disabledReason}>
      <Button {...buttonProps} disabled={Boolean(disabledReason) || disabled} />
    </DisabledReason>
  );
}
